import { render, staticRenderFns } from "./debt_by_pages.vue?vue&type=template&id=57c21ece&scoped=true&"
import script from "./debt_by_pages.vue?vue&type=script&lang=js&"
export * from "./debt_by_pages.vue?vue&type=script&lang=js&"
import style0 from "./debt_by_pages.vue?vue&type=style&index=0&id=57c21ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c21ece",
  null
  
)

export default component.exports